import { lazyLoadOnRender } from '@ms/yammer-libs-lazy';
import type { ComponentType } from 'react';

import type { UsagePolicyDialogLifecycleProps } from './UsagePolicyDialogLifecycle';

const loader = () =>
  import(/* webpackChunkName: "4-feat-usagepolicydialoglifecycle" */ './UsagePolicyDialogLifecycle').then((module) => ({
    default: module.UsagePolicyDialogLifecycle,
  }));

export const LoadableUsagePolicyDialogLifecycle: ComponentType<UsagePolicyDialogLifecycleProps> = lazyLoadOnRender({
  loader,
});
